// @flow

import * as React from 'react'
import PT from 'prop-types'
import Cookies from 'js-cookie'

import { parseQueryParams } from '#utils/location'

export type Kiosk = {|
  isKioskMode: boolean,
|}

const QUERY_PARAM_KIOSK_MODE = 'kiosk'

type Props = {
  location: { pathname: string, search: ?string },
  children: React.Node,
}

type State = {}

class KioskProvider extends React.Component<Props, State> {
  constructor(props: Props, ctx: {}) {
    super(props, ctx)

    this.setKioskMode(this.props.location)
  }

  getChildContext() {
    return {
      kiosk: ({
        isKioskMode: this.isKioskMode,
      }: Kiosk),
    }
  }

  setKioskMode = (location: { pathname: string, search: ?string }): void => {
    const pathname = location.pathname
    const queryParams = parseQueryParams(location.search)
    let kioskParam = queryParams[QUERY_PARAM_KIOSK_MODE]

    if (kioskParam) {
      /**
       * Remember that we are in kiosk mode for the rest of the
       * user session.
       */
      Cookies.set(QUERY_PARAM_KIOSK_MODE, kioskParam)
      this.isKioskMode = true
    } else {
      kioskParam = Cookies.get(QUERY_PARAM_KIOSK_MODE)
      if (pathname === '/' && ['true', '1'].includes(kioskParam)) {
        window.location.assign('/dashboard/bookings')
      }
      this.isKioskMode = !!kioskParam && ['true', '1'].includes(kioskParam)
    }
  }

  isKioskMode: boolean = false

  render() {
    return this.props.children
  }
}

KioskProvider.childContextTypes = {
  kiosk: PT.object,
}

export default KioskProvider
